import { OPTIMIZELY_FLAGS_ENUM } from '@/constants'
import { OptimizelyDecisionsProps } from '@/context/optimizely-decisions-context'

import { resolveExplorationForPlace, type ResolvedExploration } from './data'

export const resolveExplorationVariant = (
  placesId: string | undefined,
  optiContext: OptimizelyDecisionsProps,
): ResolvedExploration | null => {
  if (optiContext.isGuestApp) {
    return null
  }

  const variation = optiContext.getExperimentVariationKey(
    OPTIMIZELY_FLAGS_ENUM.AS_2696_CORNWALL_EXPLORATION,
  )

  if (variation !== 'variant_a' && variation !== 'variant_b') {
    return null
  }

  return resolveExplorationForPlace(placesId, variation)
}
